import { Component, OnInit } from '@angular/core';
import {
  WithSubscriptionComponent,
  ServiceType,
  SearchUsersCanBookForFetcher,
  EnterpriseSearchService,
  UserService,
  HelperRoutines,
  IrlJourneyType
} from '@sabstravtech/obtservices/angular';
import { Traveller, RecentSearch, LocationTypes } from '@sabstravtech/obtservices/base';

import { FADE_IN_OUT } from '../../../startup/data/animations';

@Component({
  selector: 'app-recent-searches',
  templateUrl: './recent-searches.component.html',
  styleUrls: ['./recent-searches.component.scss'],
  animations: [FADE_IN_OUT],
  standalone: false
})
export class RecentSearchesComponent extends WithSubscriptionComponent implements OnInit {
  public serviceType: typeof ServiceType = ServiceType;
  public irlJourneyType: typeof IrlJourneyType = IrlJourneyType;
  public recentSearches: RecentSearch[];
  searchParams: any; // BaseEnterpriseSearch;
  public locationTypes: typeof LocationTypes = LocationTypes;
  public removing = false;

  constructor(
    public searchUsersCanBookForFetcher: SearchUsersCanBookForFetcher,
    public searchService: EnterpriseSearchService,
    public userService: UserService
  ) {
    super();
  }

  ngOnInit() {
    this.getUserRecentSearches();
  }

  private getUserRecentSearches() {
    this.subscribe(this.searchService.getUserRecentSearches(), (data: RecentSearch[]) => {
      this.recentSearches = data.sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt));
    });
  }

  public async performRecentSearch(recentSearch: RecentSearch) {
    console.log(recentSearch);
    this.searchService.resetSearchChosenObjects();
    this.searchService.resetSearchPriorities();
    await this.addToTravellerSelection(recentSearch.travellers);

    switch (recentSearch.serviceType) {
      case ServiceType.Rail:
      case ServiceType.InternationalRail:
      case ServiceType.Hotel:
      case ServiceType.Car:
      case ServiceType.Flight:
      case ServiceType.Parking:
      case ServiceType.Lounge:
      case ServiceType.Cab:
      case ServiceType.Eurostar:
      case ServiceType.FastTrack:
        this.getParams(recentSearch);
        break;

      default:
        break;
    }
  }

  private async addToTravellerSelection(travellers: Traveller[]): Promise<void> {
    // remove exist Travellers if they are
    if (this.searchService.getCurrentNoOfTravellers() >= 1) {
      this.searchService.removeAllTravellers();
    }

    const invokedTraveller = travellers.find((traveller) => traveller.isInvoked);
    if (invokedTraveller) {
      await this.userService.setBobo(invokedTraveller);
    }
    // add recent search Travellers
    if (travellers) {
      travellers.forEach((traveller: Traveller) => {
        this.searchService.addTraveller(traveller);
      });
    }
  }

  getParams(recentSearch: RecentSearch): void {
    this.searchParams = this.searchService.searches[recentSearch.serviceType];
    this.searchService.search_objects[recentSearch.serviceType].chosen = true;
    this.searchService.search_objects[recentSearch.serviceType].originalChosen = true;
    this.searchService.highest_search_priority =
      this.searchService.search_objects[recentSearch.serviceType].priority;
    this.searchParams.startRecentSearch(recentSearch);
  }

  public removeRecentSearchItem(item: RecentSearch, $event) {
    $event.stopPropagation();

    this.subscribe(this.searchService.deleteRecentSearchByID(item.id as string), (response) => {
      if (response) {
        this.recentSearches.splice(this.recentSearches.indexOf(item), 1);
      }
    });
  }

  async removeAll() {
    this.removing = true;

    try {
      await this.searchService.deleteAllRecentSearches(false).toPromise();
      this.recentSearches = [];
    } catch (error) {
      console.error(`Error deleting all recent searches: ${error}`);
    }

    this.removing = false;
  }
}
